export default __webpack_public_path__ + "static/media/loading.d32fc190.svg";